import Layout from '@/modules/layout/components/layout';
import Permissions from '@/security/permissions';

const MetadataMapping = () => import('@/modules/metadata-mapping/pages/MetadataMapping.vue');

export default [
    {
        path: '',
        component: Layout,
        meta: { auth: true },
        children: [
            {
                name: 'metadata-mapping',
                path: '/metadata-mapping',
                component: MetadataMapping,
                meta: {
                    auth: true,
                    permission: Permissions.values.metadataMappingRead,
                }
            },
        ],
    },
];

